<div class="container-fluid">
  <div class="row row-padding">
    <div class="col">
      <label class="fs-24">Data Export</label>
    </div>
  </div>

  <div class="row row-padding">
    <div class="col">
      <button class="btn btn-primary" (click)="exportFilteredData()">
        Export filtered data
      </button>
    </div>
  </div>

  <div class="row row-padding">
    <div class="col">
      <button class="btn btn-primary" (click)="exportAllData()">
        Export all data
      </button>
    </div>
  </div>
</div>
